var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconButton',{attrs:{"color":_vm.color,"loading":_vm.loading,"mdi-icon":_vm.mdiIcon,"small-icon":_vm.smallIcon,"small-button":_vm.smallButton,"icon":""},on:{"click:prevent":(event) => _vm.$emit('click:prevent', event)}})
}
var staticRenderFns = []

export { render, staticRenderFns }